(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const track = root.querySelector('.snvu__track');
    const prev = root.querySelector('[data-snvu-prev]');
    const next = root.querySelector('[data-snvu-next]');
    const status = root.querySelector('.snvu__status');
    const updateArrows = () => {
      prev.disabled = track.scrollLeft < 2;
      next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
    };
    const move = (direction) => {
      const card = track.querySelector('.snvu__card');
      if (!card) return;
      track.scrollBy({left: direction * (card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap)), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    };
    prev.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    track.addEventListener('scroll', updateArrows, {passive:true});
    new ResizeObserver(updateArrows).observe(track);
    updateArrows();
    root.querySelectorAll('[data-snvu-choose]').forEach(button => button.addEventListener('click', () => document.getElementById(button.dataset.snvuChoose).showModal()));
    root.querySelectorAll('[data-snvu-close]').forEach(button => button.addEventListener('click', () => button.closest('dialog').close()));
    root.querySelectorAll('.snvu__form').forEach(form => form.addEventListener('submit', async event => {
      event.preventDefault();
      const button = form.querySelector('button');
      if (button.disabled) return;
      button.disabled = true;
      button.setAttribute('aria-busy','true');
      status.textContent = '';
      try {
        const data = new FormData(form);
        const drawer = document.querySelector('cart-drawer');
        const cartUi = drawer || document.querySelector('cart-notification');
        if (cartUi?.getSectionsToRender) {
          data.append('sections',cartUi.getSectionsToRender().map(s => s.id).join(','));
          data.append('sections_url',location.pathname);
        }
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js',{method:'POST',headers:{'X-Requested-With':'XMLHttpRequest'},body:data});
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || status.dataset.error);
        form.closest('dialog')?.close();
        status.textContent = status.dataset.added;
        document.dispatchEvent(new CustomEvent('cart:refresh',{detail:{source:'snvu'}}));
        if (cartUi?.renderContents && result.sections) {
          cartUi.classList.remove('is-empty');
          cartUi.renderContents(result);
        }
      } catch (error) {
        status.textContent = error.message || status.dataset.error;
      } finally {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
    }));
  }
  document.querySelectorAll('.snvu').forEach(init);
  document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('.snvu').forEach(init));
})();
